const invertedMessages = {
  Loaded: 'Auth.SuccessState.Loaded',
  'Saved!': 'Auth.SuccessState.Saved',
  'Your new client credential has been created. Save the Client ID — it cannot be retrieved again.':
    'Auth.SuccessState.ClientCreated',
  'Client deleted.': 'Auth.SuccessState.ClientDeleted',
};

export default invertedMessages;
